import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'


const _hoisted_1 = { class: "genericPadding" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  type: "submit",
  class: "genericButton bgGradient w-100 mt-5"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "underlined blue ms-1" }, "login", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_val_form = _resolveComponent("val-form")!
  const _directive_localizedPlaceholder = _resolveDirective("localizedPlaceholder")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "backbutton",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
    }, [
      _hoisted_2
    ]),
    _createVNode(_component_localized_text, {
      localizedKey: "app_passworddimenticata",
      text: "Password dimenticata",
      class: "fs_28 spaceCadet d-block mt-2"
    }),
    _createVNode(_component_localized_text, {
      localizedKey: "app_inseriscilatuaemailperriceverelatuanuovapassword",
      text: "Inserisci la tua email per ricevere la nuova password",
      class: "fs_16 grey d-block mb-5"
    }),
    _createVNode(_component_val_form, {
      onSubmit: _ctx.resetPassword,
      onInvalid: _ctx.doError,
      class: "loginContainer"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_3, [
          _withDirectives(_createVNode("input", {
            type: "email",
            class: "genericInput",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.username = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.username],
            [_directive_localizedPlaceholder, {key: 'app_email', value: 'Email', afterText : '*'}]
          ])
        ]),
        _createVNode("button", _hoisted_4, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_resetpassword",
            text: "Reset password",
            class: "fs_14 white"
          })
        ]),
        _createVNode(_component_router_link, {
          tag: "div",
          to: "/login",
          class: "d-block mt-5 text-center ln_12 pointer",
          style: {"text-decoration":"none"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_localized_text, {
              localizedKey: "app_tornaAlla",
              text: "Torna alla",
              class: "grey"
            }),
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onSubmit", "onInvalid"])
  ]))
}